import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* generalBase(action) {
    const url = api.buildGeneralBaseUrl();
    //const authGet = yield authenticatedRequest(FetchService.get);
    const {response, data} = yield call(FetchService.get, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.generalBaseResponse({ payload: {data: data}, error: error }));
}

function* watchGeneralBase() {
    yield takeLatest(ty.GENERAL_BASE_REQUEST, errorSafeSaga(generalBase));
}


function* saga() {
  yield all([
    fork(watchGeneralBase)
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/general/saga.js